export default "__VITE_ASSET__e978170c__"